module.exports = __webpack_public_path__ + "img/ok.d1d948b1.svg";